import React, { useEffect, useRef, useState } from 'react';
import { apiClient } from '../../utils/apiClient';
import { useReviewRequest } from './useReviewRequest';
import { ReviewChannelRow } from './ReviewChannelRow';

export const ReviewRequestStep = ({ pet, checked, onChange, onComplete, openSMSModal, openEmailModal }) => {
  const { state, error, retry } = useReviewRequest(pet);
  const [canceling, setCanceling] = useState(false);
  const [cancelError, setCancelError] = useState('');
  const completed = state?.completed;
  const previousCompleted = useRef();
  // React to a new server completion, not historical delivery proof. A local
  // untick must survive status polling, and a saved reset must survive reopen.
  useEffect(() => {
    if (previousCompleted.current === false && completed) onComplete();
    if (completed !== undefined) previousCompleted.current = completed;
  }, [completed, onComplete]);
  const cancel = async (id) => {
    setCanceling(true); setCancelError('');
    try { await apiClient.delete(`/sms/scheduled/${id}`); retry(); }
    catch (_) { setCancelError('Unable to cancel. The SMS may already be sending.'); retry(); }
    finally { setCanceling(false); }
  };
  return (
    <section className="bg-teal-50 border border-teal-200 p-3 rounded-lg" data-testid="workflow-review-step-card">
      <div className="flex items-center justify-between gap-2 mb-1">
        <label className="flex min-w-0 items-center gap-2 text-sm font-medium text-gray-800">
          <input type="checkbox" checked={!!checked}
            onChange={event => onChange(event.target.checked)} data-testid="workflow-review-completed-checkbox"
            className="rounded border-gray-300 text-teal-600 focus:ring-teal-500" />
          Review Request
        </label>
        <span data-testid="workflow-review-status-badge" className={`text-xs shrink-0 ${checked ? 'text-green-700' : 'text-gray-500'}`}>
          {checked ? 'Completed' : 'Pending'}
        </span>
      </div>
      {checked && state?.legacy_recorded && <p className="text-xs text-gray-500" data-testid="review-legacy-recorded">Completion recorded previously</p>}
      {!state && !error && <p className="text-xs text-gray-500" data-testid="review-status-loading">Loading…</p>}
      {(error || cancelError) && <div className="flex gap-2 items-center text-xs text-red-700" role="alert" data-testid="review-status-error">
        <span>{error || cancelError}</span>
        <button type="button" onClick={retry} className="underline" data-testid="review-status-retry">Retry</button>
      </div>}
      <div className="divide-y divide-teal-100">
        <ReviewChannelRow channel="sms" label="SMS" data={state?.sms} available={!!pet.phone_number}
          blocked={!state || !!error || canceling} onSend={() => openSMSModal(pet.id, 'review_sms')} onCancel={cancel} />
        <ReviewChannelRow channel="email" label="Email" data={state?.email} available={!!pet.email}
          blocked={!state || !!error} onSend={() => openEmailModal(pet.id, 'review_request')} />
      </div>
    </section>
  );
};